import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * agenciesSelectionSets is a "grouping" of multiple agencies that are
   * selected. For example, one might wish to have a "global" set of
   * selected agencies that is persistent across all screens or one
   * might want to create a set of selected agencies for a particular
   * individual/group of widgets.
   */
  agencySelectionSets: {}
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected agencies.
   *
   * @param state Object
   *
   * @return Object
   */
  agencySelectionSets (state) {
    return state.agencySelectionSets
  }
}

export const actions = {
  /**
   * Query/find one or more agencies.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    return ApiService
      .get(`agencies`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Add a map or array of object agencies that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param agencies Array|Map
   */
  addSelectedAgencies (state, { set, agencies }) {
    if (!state.agencySelectionSets.hasOwnProperty(set)) {
      Vue.set(state.agencySelectionSets, set, {})
    }

    agencies.forEach(agency => {
      Vue.set(state.agencySelectionSets[set], agency.id, agency)
    })
  },

  /**
   * Set a single selected agency, all other selected agencies
   * in the set will be cleared.
   *
   * @param state  Object
   * @param set    String
   * @param agency Object
   */
  setSelectedAgency (state, { set, agency }) {
    Vue.set(state.agencySelectionSets, set, {})
    Vue.set(state.agencySelectionSets[set], agency.id, agency)
  },

  /**
   * Removes an array of agencies from the set's list of selected agencies.
   * The array must consist of the id's of the agencies that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param agencies Array
   */
  removeSelectedAgencies (state, { set, agencies }) {
    if (state.agencySelectionSets.hasOwnProperty(set)) {
      agencies.forEach(agency => {
        Vue.delete(state.agencySelectionSets[set], agency.id)
      })
    }
  },

  /**
   * Clears all selected agencies.
   *
   * @param state  Object
   */
  clearAllSelectedAgencies (state) {
    Vue.set(state, 'agencySelectionSets', {})
  },

  /**
   * Clears all selected agencies within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedAgencies (state, set) {
    if (state.agencySelectionSets.hasOwnProperty(set)) {
      Vue.set(state.agencySelectionSets, set, {})
    }
  },

  /**
   * Clears all agencies.
   *
   * @param state Object
   */
  purge (state) {
    state.agencySelectionSets = {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/administration/agencies/findAgenciesWidgetModule.js